module.exports = __webpack_public_path__ + "img/companyIntro35.862a6be3.png";